import React from 'react'
import TryButton from './TryButton'
import clsx from 'clsx'
import { useNavigate } from 'react-router-dom'

interface ScanCompletedModalProps {
  hideCondition: boolean
  showCondition: boolean
}

const ScanCompletedModal = (props: ScanCompletedModalProps) => {
  const { hideCondition, showCondition } = props
  const navigate = useNavigate()
  return (
    <div
      className={clsx(
        'absolute bg-scanModalBgDark dark:bg-scanModalBg rounded-5.5xl top-[60%] left-1/2 -translate-x-1/2 -translate-y-1/2 w-[327px] flex flex-col items-center gap-6 p-6',
        {
          'opacity-0 pointer-events-none transition-opacity duration-200': hideCondition,
          'opacity-100 transition-opacity duration-200': showCondition,
        },
      )}
    >
      <div className="absolute top-6 left-1/2 -translate-x-1/2 max-w-[135px]">
        <img src="/svg/scan-modal-svg.svg" alt="Scan Completed!" />
      </div>
      <img src="/img/scan/1.png" alt="Scan Completed!" className="max-w-[100px] block" />
      <h3 className="text-center text-XL font-bold">Scan Completed!</h3>
      <div className="w-full flex flex-col gap-4 [&>div]:flex [&>div]:justify-between [&>div>div]:grow [&>div>div]:mx-0.5 [&>div>div]:mb-1 [&>div>div]:border-b-[2px] [&>div>div]:border-dotted [&>div>div]:border-white/50 [&>div>p]:text-logo [&>div>p]:text-center">
        <div>
          <p>Total space to free</p>
          <div></div>
          <p className="text-yellowDark">54.5 GB</p>
        </div>
        <div>
          <p>Photos ready for removal</p>
          <div></div>
          <p className="blur-[3px]">238</p>
        </div>
        <div>
          <p>Duplicate photos</p>
          <div></div>
          <p className="blur-[3px]">238</p>
        </div>
      </div>
      <TryButton
        text="Continue"
        onClick={() => {
          navigate('/email')
        }}
      />
    </div>
  )
}

export default ScanCompletedModal
